export default __webpack_public_path__ + "static/media/1-1-4.b300ba10.jpg";